import { createContext, useContext, useState } from 'react'

export interface OrganisationContextType {
  setHasUnsavedChanges: (val: boolean) => void
  hasUnsavedChanges: boolean
}

export const OrganisationContext = createContext<OrganisationContextType>({
  setHasUnsavedChanges: () => {},
  hasUnsavedChanges: false,
})

export const InitialiseOrganisationContext = () => {
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false)
  return {
    hasUnsavedChanges,
    setHasUnsavedChanges,
  }
}

export const useOrganisationContext = () => {
  const ctx = useContext<OrganisationContextType>(OrganisationContext)

  return { ...ctx }
}
